import type { PlayerPosition } from '../../types'
import { POSITION_ICONS } from './pitchLayouts'

type PlayerLike = {
  id: number
  name: string
  photo_url?: string
}

// Circular pitch token — empty dashed ring or filled photo badge.
export default function PitchPlayerToken({
  player,
  position,
  isActive = false,
  emptyHint,
  floatKey = 0,
  locked = false,
  onClick,
  onRemove,
}: {
  player?: PlayerLike | null
  position: PlayerPosition
  isActive?: boolean
  emptyHint?: string
  floatKey?: number
  locked?: boolean
  onClick?: () => void
  onRemove?: () => void
}) {
  const floatStyle = player
    ? {
        animationDelay: `${(floatKey % 8) * 0.16}s`,
        animationDuration: `${2.0 + (floatKey % 4) * 0.25}s`,
      }
    : undefined

  const body = (
    <>
      {player ? (
        <span key={player.id} className="pitch-card-pop pitch-token-face">
          <img
            src={player.photo_url || '/placeholder.png'}
            alt={player.name}
            className="pitch-token-photo"
            onError={(e) => {
              e.currentTarget.src = '/placeholder.png'
            }}
          />
          <span className="pitch-token-name">{player.name}</span>
          {onRemove && !locked && (
            <span
              role="button"
              tabIndex={-1}
              onClick={(e) => {
                e.stopPropagation()
                onRemove()
              }}
              className="pitch-token-remove"
            >
              ×
            </span>
          )}
        </span>
      ) : (
        <span className="pitch-token-empty">
          <span className="pitch-token-icon">{POSITION_ICONS[position]}</span>
          {emptyHint && <span className="pitch-token-hint">{emptyHint}</span>}
        </span>
      )}
    </>
  )

  if (!onClick) {
    return (
      <div
        className={`pitch-token ${player ? 'pitch-card-float pitch-token-filled' : 'pitch-token-vacant'}`}
        style={floatStyle}
      >
        {body}
      </div>
    )
  }

  return (
    <div className={player ? 'pitch-card-float' : undefined} style={floatStyle}>
      <button
        type="button"
        onClick={onClick}
        className={`pitch-token ${
          isActive ? 'pitch-token-active' : player ? 'pitch-token-filled' : 'pitch-token-vacant'
        } ${locked ? 'cursor-default' : 'active:scale-95'}`}
      >
        {body}
      </button>
    </div>
  )
}
